import { render, staticRenderFns } from "./EditOrg.vue?vue&type=template&id=4ac2d7c3&scoped=true&"
import script from "./EditOrg.vue?vue&type=script&lang=js&"
export * from "./EditOrg.vue?vue&type=script&lang=js&"
import style0 from "./EditOrg.vue?vue&type=style&index=0&id=4ac2d7c3&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac2d7c3",
  null
  
)

export default component.exports